// Tyre choice during a pit stop: shown while the car drives itself down the
// pit lane, so the player picks before it reaches the box. The engineer's
// suggestion is preselected.

import { addTapHaptic } from '../input/haptics';
import { ALL_COMPOUNDS, COMPOUNDS, type Compound } from '../race/tyres';

export class PitMenu {
  private readonly el: HTMLElement;
  private readonly note: HTMLElement;
  private readonly buttons = new Map<Compound, HTMLButtonElement>();
  choice: Compound = 'medium';
  locked = false;

  constructor(root: HTMLElement) {
    this.el = document.createElement('div');
    this.el.className = 'pit-menu';
    this.el.innerHTML = `<div class="pit-title">Pit stop: choose tyres</div><div class="pit-tyres"></div><div class="pit-note"></div>`;
    root.appendChild(this.el);
    this.el.addEventListener('pointerdown', (e) => e.stopPropagation());
    this.note = this.el.querySelector('.pit-note') as HTMLElement;
    const row = this.el.querySelector('.pit-tyres') as HTMLElement;
    for (const c of ALL_COMPOUNDS) {
      const spec = COMPOUNDS[c];
      const b = document.createElement('button');
      b.className = 'pit-tyre';
      b.innerHTML = `<span style="border-color:${spec.color};color:${spec.color}">${spec.letter}</span><small>${spec.name}</small>`;
      b.addEventListener('click', () => {
        if (this.locked) return;
        this.choice = c;
        this.render();
      });
      addTapHaptic(b);
      this.buttons.set(c, b);
      row.appendChild(b);
    }
  }

  show(suggested: Compound, note: string): void {
    this.choice = suggested;
    this.locked = false;
    this.note.textContent = note;
    this.render();
    this.el.classList.add('show');
  }

  get shown(): boolean {
    return this.el.classList.contains('show');
  }

  /** Step the tyre choice left/right (wheel paddles). */
  cycle(dir: 1 | -1): void {
    if (this.locked || !this.shown) return;
    const i = ALL_COMPOUNDS.indexOf(this.choice);
    this.choice = ALL_COMPOUNDS[(i + dir + ALL_COMPOUNDS.length) % ALL_COMPOUNDS.length]!;
    this.render();
  }

  setNote(note: string): void {
    this.note.textContent = note;
  }

  /** Lock in the choice as the car stops in the box. */
  lock(): void {
    this.locked = true;
    this.render();
  }

  hide(): void {
    this.el.classList.remove('show');
  }

  private render(): void {
    for (const [c, b] of this.buttons) {
      b.classList.toggle('chosen', c === this.choice);
      b.disabled = this.locked && c !== this.choice;
    }
  }
}
